import fetch from '../utils/fetch';

const BaseUrl = process.env.MONO_BASE;
const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  /**
   * Fetch list of available PDK partners,
   * along with any token info if user has already connected their accounts.
   */
  getPartners: () => fetch(getUrl('/partners')),

  /**
   * Fetch list of Experiences by Partner. For the most part these experiences
   * are scoped to the logged-in user, but some partners might have generic
   * Experiences for all their users.
   */
  getExperiences: (partner) => fetch(getUrl(`/partners/${partner}/experiences`)),

  /**
   * Fetch list of available charts from SportsGold API. Request is proxied to SportsGold API as-is.
   */
  getFoxForesightCharts: () => fetch(getUrl('/partners/sportsgold/charts')),

  /**
   * Fetch list of available games by date and sport from SportsGold API.
   * Request is proxied as-is to SportsGold API.
   */
  getFoxForesightGames: (date, sport) => {
    const params = new URLSearchParams({ day: date });
    if (sport) {
      params.append('sport', sport);
    }

    return fetch(getUrl(`/partners/sportsgold/games?${params.toString()}`));
  },

  /**
   * Get available options for a specific chart and game.
   * This can include players, batter hand, etc. which will appear as dropdowns
   * for the user to choose from.
   */
  getFoxForesightChartOptions: (chartType, gameId) => fetch(getUrl(`/partners/sportsgold/charts/${chartType}/options?game_id=${gameId}`)),
};
